import React from 'react';

export default function Gizlilik() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111',
      color: '#eee',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: '40px 20px',
    }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <div style={{ marginBottom: 32 }}>
          <a href="/login" style={{ color: '#C41E3A', textDecoration: 'none', fontSize: 14 }}>
            ← Giriş Sayfasına Dön
          </a>
        </div>

        <h1 style={{ color: '#fff', fontSize: 28, fontWeight: 800, marginBottom: 8 }}>
          Gizlilik Politikası
        </h1>
        <p style={{ color: '#888', fontSize: 14, marginBottom: 40 }}>
          Son güncelleme: Nisan 2025
        </p>

        <Section title="1. Veri Sorumlusu">
          <p>
            istanbulTANGO uygulaması, Meet Sanat Ltd tarafından işletilmektedir.
            Kişisel verileriniz, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında
            veri sorumlusu sıfatıyla tarafımızca işlenmektedir.
          </p>
        </Section>

        <Section title="2. Toplanan Veriler">
          <p>Uygulama aracılığıyla aşağıdaki kişisel veriler toplanmaktadır:</p>
          <ul>
            <li><strong>Kimlik bilgileri:</strong> Ad, soyad, e-posta adresi</li>
            <li><strong>İletişim bilgileri:</strong> Telefon numarası</li>
            <li><strong>Demografik bilgiler:</strong> Cinsiyet</li>
            <li><strong>Profil fotoğrafı</strong> (isteğe bağlı)</li>
            <li><strong>Ders ve katılım bilgileri:</strong> Kayıtlı dersler, yoklama kayıtları</li>
            <li><strong>Kredi ve ödeme geçmişi</strong></li>
            <li><strong>Cihaz bilgileri:</strong> Bildirim için push token</li>
          </ul>
        </Section>

        <Section title="3. Verilerin Kullanım Amaçları">
          <ul>
            <li>Üyelik hesabı oluşturma ve yönetimi</li>
            <li>Ders kaydı ve katılım takibi</li>
            <li>Yoklama ve QR kimlik doğrulaması</li>
            <li>Bildirim gönderimi</li>
            <li>Eğitmen-öğrenci iletişimi</li>
            <li>Kredi ve ödeme işlemlerinin yürütülmesi</li>
            <li>Yasal yükümlülüklerin yerine getirilmesi</li>
          </ul>
        </Section>

        <Section title="4. Kamera ve Galeri Erişimi">
          <p>
            Uygulama, aşağıdaki amaçlarla cihaz donanımına erişim talep edebilir:
          </p>
          <ul>
            <li>
              <strong>Kamera:</strong> QR kod okutarak yoklamaya katılmak için kullanılır.
              Kamera yalnızca QR tarama ekranı açıkken aktif olur.
            </li>
            <li>
              <strong>Fotoğraf Galerisi:</strong> Profil fotoğrafı yüklemek için kullanılır.
              Seçilen fotoğraf yalnızca profilinize yüklenir.
            </li>
          </ul>
          <p>Bu izinler kullanılmadığında arka planda çalışmaz.</p>
        </Section>

        <Section title="5. Bildirimler">
          <p>
            Uygulama, ders hatırlatmaları, duyurular ve mesajlar için push bildirimleri gönderebilir.
            Bildirim izni isteme sırasında reddedebilir veya cihaz ayarlarından dilediğiniz zaman
            devre dışı bırakabilirsiniz.
          </p>
        </Section>

        <Section title="6. Verilerin Paylaşımı">
          <p>Kişisel verileriniz aşağıdaki durumlar dışında üçüncü taraflarla paylaşılmaz:</p>
          <ul>
            <li>Yasal zorunluluk veya resmi talep durumunda ilgili kamu kurumlarıyla</li>
            <li>Fotoğraf depolama hizmeti olarak Cloudinary (yalnızca profil fotoğrafı)</li>
            <li>E-posta/SMS doğrulama hizmeti (yalnızca OTP kodu iletimi)</li>
          </ul>
        </Section>

        <Section title="7. Veri Saklama Süresi">
          <p>
            Kişisel verileriniz, üyeliğiniz aktif olduğu sürece saklanır. Hesabınızı silmeniz
            durumunda verileriniz, yasal saklama yükümlülükleri saklı kalmak kaydıyla silinir
            veya anonim hale getirilir.
          </p>
        </Section>

        <Section title="8. Haklarınız">
          <p>KVKK kapsamında sahip olduğunuz haklar:</p>
          <ul>
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
            <li>İşlenmişse buna ilişkin bilgi talep etme</li>
            <li>Verilerin düzeltilmesini isteme</li>
            <li>Verilerin silinmesini veya yok edilmesini isteme</li>
            <li>İşlemeye itiraz etme</li>
          </ul>
          <p>
            Bu haklarınızı kullanmak için{' '}
            <a href="mailto:iletisim@istanbultango.com" style={{ color: '#C41E3A' }}>
              iletisim@istanbultango.com
            </a>{' '}
            adresine yazabilirsiniz.
          </p>
        </Section>

        <Section title="9. Güvenlik">
          <p>
            Verileriniz, endüstri standardı SSL/TLS şifrelemesi ve güvenli sunucu altyapısı
            üzerinde saklanmaktadır. Şifreler düz metin olarak tutulmaz; tüm kimlik doğrulama
            OTP veya OAuth ile yapılmaktadır.
          </p>
        </Section>

        <Section title="10. İletişim">
          <p>
            Gizlilik politikamızla ilgili sorularınız için:
            <br />
            <a href="mailto:iletisim@istanbultango.com" style={{ color: '#C41E3A' }}>
              iletisim@istanbultango.com
            </a>
          </p>
        </Section>

        <div style={{ borderTop: '1px solid #333', paddingTop: 24, marginTop: 40, color: '#555', fontSize: 12, textAlign: 'center' }}>
          © 2025 Meet Sanat Ltd — Tüm hakları saklıdır.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h2 style={{ color: '#fff', fontSize: 18, fontWeight: 700, marginBottom: 12, borderLeft: '3px solid #C41E3A', paddingLeft: 12 }}>
        {title}
      </h2>
      <div style={{ color: '#bbb', lineHeight: 1.7, fontSize: 15 }}>
        {children}
      </div>
    </div>
  );
}
